import React from 'react';
import { ErrorModalProps } from '../types';
import ErrorModal from './ErrorModal';
import { updatePayment } from '@/api/payment';
import { formRequest } from '@/utils/helpers';
import { trackHelper } from '@/analytics/utils';
import { ANALYTICS_ACTIONS, EVENT_NAMES } from '@/analytics/constants';
import { useGlobalStore } from '@/store';

export const PaymentCancelWrapper = (props: ErrorModalProps): JSX.Element => {
  const { activeView } = useGlobalStore();
  const handleCancel = async (): Promise<void> => {
    try {
      const res = await updatePayment({
        status: 'failed',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        failure_reason: 'cancelled_by_user',
      });
      if (res.data.gateway_payload) {
        const { url, payload, method } = res.data.gateway_payload;
        formRequest(url, payload, method);
        // Track Change Payment Method clicked
        trackHelper({
          objectName: EVENT_NAMES.CHANGE_PAYMENT_METHOD,
          actionName: ANALYTICS_ACTIONS.CLICK,
          screen: activeView,
        });
      }
    } catch (error: unknown) {
      //
    }
  };

  return <ErrorModal {...props} onCtaClick={props.onCtaClick ? props.onCtaClick : handleCancel} />;
};
